import type { ReactNode } from "react";

type TabPanelProps = {
  active: boolean;
  children: ReactNode;
};

/**
 * Wraps tab content with consistent display:none toggling.
 * Content stays mounted when hidden to preserve form state.
 */
export function TabPanel({ active, children }: TabPanelProps) {
  return <div style={{ display: active ? undefined : "none", width: "100%" }}>{children}</div>;
}
